import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown, ChevronRight, Phone, MessageCircle, Home, Smile, Activity, Shield, Zap, Heart, Sparkles, Stethoscope } from 'lucide-react';
import { menuItems, clinicInfo } from '../data/servicesData';

// Icon mapping for menu categories
const categoryIcons = {
  'Home': Home,
  'Dental Checkup': Stethoscope,
  'Aligners Studio': Smile,
  'Braces Treatment': Activity,
  'Dental Implants': Shield,
  'Dental Surgery': Zap,
};

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const getCategoryIcon = (title) => {
    return categoryIcons[title] || Sparkles;
  };

  return (
    <header className="header-wrapper">
      <div className="header-container">
        <div className="header-content">
          <Link to="/" className="logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_0256d13d-9170-4042-be2c-1474dbb0098c/artifacts/epkbvjxo_dr.thamarai%27s%20dental%20care%20chennai%20Logo.svg" 
              alt="Dr. Thamarai's Dental Care Chennai"
              className="logo-image"
            />
          </Link>

          <nav className="desktop-nav">
            {menuItems.map((item, index) => (
              <div
                key={index}
                className="nav-item"
                onMouseEnter={() => item.submenu && setActiveDropdown(index)}
                onMouseLeave={() => setActiveDropdown(null)}
              >
                {item.submenu ? (
                  <>
                    <button className="nav-link">
                      {item.title}
                      <ChevronDown size={16} className="chevron-icon" />
                    </button>
                    {activeDropdown === index && (
                      <div className="dropdown-menu">
                        {item.submenu.map((subitem, subindex) => (
                          <Link
                            key={subindex}
                            to={subitem.path}
                            className="dropdown-item"
                          >
                            {subitem.title}
                          </Link>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <Link to={item.path} className="nav-link">
                    {item.title}
                  </Link>
                )}
              </div>
            ))}
          </nav>

          <div className="header-actions">
            <a 
              href="tel:+917502297680" 
              className="header-icon-button phone-button"
              aria-label="Call us"
            >
              <Phone size={22} />
            </a>
            <a 
              href="https://wa.me/917502297680" 
              target="_blank"
              rel="noopener noreferrer"
              className="header-icon-button whatsapp-button"
              aria-label="WhatsApp us"
            >
              <MessageCircle size={22} />
            </a>
          </div>

          <button
            className="mobile-menu-button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={() => setMobileMenuOpen(false)}>
          <div className="mobile-menu-drawer" onClick={(e) => e.stopPropagation()}>
            {/* Mobile Menu Header */}
            <div className="mobile-menu-header">
              <img 
                src="https://customer-assets.emergentagent.com/job_0256d13d-9170-4042-be2c-1474dbb0098c/artifacts/epkbvjxo_dr.thamarai%27s%20dental%20care%20chennai%20Logo.svg" 
                alt="Logo"
                className="mobile-menu-logo"
              />
              <button 
                className="mobile-menu-close"
                onClick={() => setMobileMenuOpen(false)}
              >
                <X size={24} />
              </button>
            </div>

            {/* Mobile Menu Content */}
            <div className="mobile-menu-content">
              <h3 className="mobile-menu-title">Services</h3>
              
              {menuItems.map((item, index) => {
                const IconComponent = getCategoryIcon(item.title);
                
                return (
                  <div key={index} className="mobile-menu-category">
                    {item.submenu ? (
                      <>
                        <button
                          className="mobile-category-header"
                          onClick={() => setActiveDropdown(activeDropdown === index ? null : index)}
                        >
                          <div className="mobile-category-icon">
                            <IconComponent size={24} />
                          </div>
                          <div className="mobile-category-info">
                            <span className="mobile-category-title">{item.title}</span>
                            <span className="mobile-category-count">{item.submenu.length} services</span>
                          </div>
                          <div className={`mobile-category-arrow ${activeDropdown === index ? 'active' : ''}`}>
                            <ChevronDown size={20} />
                          </div>
                        </button>
                        
                        {activeDropdown === index && (
                          <div className="mobile-submenu-list">
                            {item.submenu.map((subitem, subindex) => (
                              <Link
                                key={subindex}
                                to={subitem.path}
                                className="mobile-submenu-item"
                                onClick={() => setMobileMenuOpen(false)}
                              >
                                <span>{subitem.title}</span>
                                <ChevronRight size={16} />
                              </Link>
                            ))}
                          </div>
                        )}
                      </>
                    ) : (
                      <Link
                        to={item.path}
                        className="mobile-category-header"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        <div className="mobile-category-icon">
                          <IconComponent size={24} />
                        </div>
                        <div className="mobile-category-info">
                          <span className="mobile-category-title">{item.title}</span>
                          <span className="mobile-category-count">Main page</span>
                        </div>
                        <div className="mobile-category-arrow">
                          <ChevronRight size={20} />
                        </div>
                      </Link>
                    )}
                  </div>
                );
              })}
            </div>

            {/* Mobile Menu Footer */}
            <div className="mobile-menu-footer">
              <a href={`tel:${clinicInfo.phone}`} className="mobile-menu-cta">
                <Phone size={18} />
                Call {clinicInfo.phone}
              </a>
              <a 
                href="https://wa.me/917502297680" 
                target="_blank" 
                rel="noopener noreferrer"
                className="mobile-menu-cta secondary"
              >
                <MessageCircle size={18} />
                WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
